import Button from './Button';
import HoverBubble from './HoverBubble';

export default function ValidatedButton({ validations = [], ...props }) {
	return <HoverBubble content={validations.filter(v => !v.valid).map((v, idx) => <p key={idx} style={{ paddingBottom: '4px' }}>{v.error}</p>)}>
		<Button {...props} />
	</HoverBubble>;
}